import { RecentQuotes } from '@dav-model/api/response/recent-quotes.response.model';
import { UserResponse, Markup } from '@dav-model/login/response/user.response.model';
import { CurrentUsers, AvailableRole } from '@dav-model/response/getuser.response';

import * as UserActions from './user.actions';

export interface State {
  isAuthenticated: boolean;
  user: UserResponse;
  originalUser: UserResponse;
  error: string;
  success: boolean;
  sessionExpired: boolean;
  markup: Markup;
  recentQuotes: RecentQuotes[];
  previousUser: string;
  appVersion: string;
  pendingContracts: number;
  emulatedDealer: boolean;
  // Dealer Admin
  users: CurrentUsers[];
  roles: AvailableRole[];
}

const InitialState: State = {
  user: undefined,
  originalUser: undefined,
  recentQuotes: [],
  isAuthenticated: false,
  error: '',
  pendingContracts: 0,
  success: false,
  sessionExpired: false,
  markup: new Markup(),
  previousUser: '',
  appVersion: '',
  emulatedDealer: false,
  users: [],
  roles: [],
};

export function reducer(state = InitialState, action: UserActions.All): State {
  switch (action.type) {
    case UserActions.LOGIN_SUCCESS: {
      const user = {
        ...action.payload.response,
        siteInfo: {
          ...action.payload.response.siteInfo,
          appEmail2: action.payload.response.siteInfo.appEmail2 || 'dealersupport@adventureprotect.ca',
          dealerSupportPhoneNumber2: action.payload.response.siteInfo.dealerSupportPhoneNumber2 || '833-954-0079',
        },
      };

      return {
        ...state,
        user: user,
        originalUser: user,
        markup: action.payload.response.userDefaults.markup,
        isAuthenticated: true,
        success: true,
      };
    }

    case UserActions.EMULATE_DEALER_SUCCESS: {
      const user = JSON.parse(JSON.stringify(state.originalUser));

      return {
        ...state,
        originalUser: user,
        user: action.user,
        emulatedDealer: true,
      };
    }

    case UserActions.RESET_DEALER: {
      return {
        ...state,
        user: state.originalUser,
        emulatedDealer: false,
      };
    }

    case UserActions.LOGIN_FAILURE: {
      return {
        ...state,
        success: false,
        error: action.payload,
      };
    }

    case UserActions.SAVE_MARKUP: {
      return {
        ...state,
        markup: action.payload,
      };
    }

    case UserActions.UPDATE_PENDING_NUMBER: {
      return {
        ...state,
        pendingContracts: action.payload,
      };
    }

    case UserActions.GET_RECENT_QUOTES_SUCCESS: {
      return {
        ...state,
        recentQuotes: action.payload,
      };
    }

    case UserActions.DELETE_QUOTE_SUCCESS: {
      return {
        ...state,
        recentQuotes: action.payload,
      };
    }

    case UserActions.UPDATE_PREVIOUS_USER: {
      return {
        ...state,
        previousUser: action.payload,
      };
    }

    case UserActions.UPDATE_VERSION: {
      return {
        ...state,
        appVersion: action.payload,
      };
    }

    case UserActions.LOGOUT_SUCCESS: {
      return {
        ...state,
        user: undefined,
        originalUser: undefined,
        emulatedDealer: false,
        recentQuotes: [],
        isAuthenticated: false,
        error: '',
        success: false,
        sessionExpired: false,
        markup: new Markup(),
      };
    }

    default: {
      return state;
    }
  }
}
